import { clsx, type ClassValue } from 'clsx';
import type { CountryCode } from 'libphonenumber-js';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format a raw phone string into national format (e.g. "(949) 889-2818").
 * @param raw    The raw phone value (E.164, local, or anything libphonenumber-js accepts).
 * @param fallback Returned as-is when `raw` is empty/null/unparseable.
 * @param country  ISO 3166-1 alpha-2 country code for parsing context (defaults to "US").
 */
export function formatPhone(
  raw: string | null | undefined,
  fallback: string,
  country?: CountryCode | null,
): string {
  if (!raw) return fallback;
  try {
    const parsed = parsePhoneNumberFromString(raw, country ?? 'US');
    return parsed ? parsed.formatNational() : raw;
  } catch {
    return raw;
  }
}

export function ensureHrefProtocol(href: string): string {
  if (/^https:\/\//i.test(href)) return href;
  if (/^http:\/\//i.test(href)) return href.replace(/^http:/i, 'https:');
  return `https://${href}`;
}
